import { render, staticRenderFns } from "./LeadFollowUp.vue?vue&type=template&id=e45da180&"
import script from "./LeadFollowUp.vue?vue&type=script&lang=js&"
export * from "./LeadFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports